export const AccountFlagNames = {
    isMultiStepIdVerification: 'ops.isMultiStepIdVerification',
    isAddNewBankAccountEnabled: 'ops.isAddNewBankAccountEnabled',
    isAccountReopeningEnabled: 'ops.isAccountReopeningEnabled',
    isInputMaskingEnabled: 'btlr.isInputMaskingEnabled',
    isAlternativeRegistrationEnabled: 'ops.isAlternativeRegistrationEnabled',
    isAlternativeRegistrationByParamEnabled: 'ops.isAlternativeRegistrationByParamEnabled',
    isTransaksEnabled: 'btlr.isTransaksEnabled',
    isLoadChatOnPageLoad: 'ops-reopen-the-chatwidget-messenger-trigger',
    isProfileEdit: 'ops.profileEdit',
    zendeskMetadata: 'ops.zendesk.metadata',
    isQuickDepositEnabled: 'web.deposit.isQuickDepositEnabled',
    isMobileQuickDepositEnabled: 'web.deposit.mobile.isQuickDepositEnabled',
    multistepRegisterBannerPlacement: 'multistepRegisterBannerPlacement',
    isRegistrationExperimentEnabled: 'isRegistrationExperimentEnabled',
    isCasinoGamesOnHomePageExperimentEnabled: 'show-casino-section-in-sports-home',
    whichAdditionalDepositButtonShown: 'additional-deposit-button-a-b-c-test',
    whichPE92ExperimentVariant: 'pe-92-experiment-variant',
    whichPE124ExperimentVariant: 'pe-124-experiment-variant',
    isLivePageShownAfterLogin: 'pe156.is-live-page-shown-after-login',
    isExitRegistrationShown: 'isExitRegistrationShown',
    isCaptiveKycEnabled: 'pam.isCaptiveKycFlowEnabled',
    hasBonusCodeOnRegistration: 'pam.has-bonus-code-on-register',
    isExtendedFtdReminderEnabled: 'is-extended-ftd-reminder-enabled',
    abcTestFloatingPlaceBetButton: 'grwt.floating-place-bet-button-abc-test',
    isPE123OnboardingChallengeEnabled: 'grwt.is-PE-123-onboarding-challenge-enabled',
    enableDesignSurveyVariant: 'grtw.enable-design-survey-variant',
    pe131DescriptiveOddName: 'pe-131-experiment-variant',
    whichOnboardingSurveyVariant: 'which-pe-162-onboarding-survey-variant',
    isCaptiveKycUnskippable: 'captive-kyc-experiment',
    whichInpirationalCopyVariant: 'grtw.pe160.whichInspirationalCopyShown',
    isSeonForComtradeEnabled: 'seon.enabled',
    pe189LowBalanceBetslipVariant: 'pe-189-low-balance-betslip',
    showBalanceInAllPages: 'pe190-show-balance-in-all-pages',
} as const;
